// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__2_Ykg","hamburger":"Sidebar_hamburger__1chol","linksContainer":"Sidebar_linksContainer__3QHBs","sidebarOpen":"Sidebar_sidebarOpen__2y4WC"};